module.exports = __webpack_public_path__ + "img/54.8328d5ce.jpg";